<template>
  <ValidationObserver :ref="`participantsobserver-${randomId}`" name="participants">
    <div class="row">
      <div class="col-md-3 col-12 mt-1">
        <div style="display: inline-flex">
          <div>
            <p class="font-weight-bold mt-4 pt-3 pl-5">
              {{ groupName }}
            </p>
          </div>
        </div>
      </div>
      <div class="col mt-1" :class="{ 'mr-md-4': !isRemovable }">
        <div class="row">
          <div class="col-md-4 col-12 mt-1">
            <ValidationProvider
              v-slot="{ errors }"
              immediate
              :rules="required && !isDisabled ? 'required' : ''"
            >
              <CustomDropDown
                v-model="internalValue.positionId"
                label="Puesto:"
                :disabled="isDisabled || positionDisabled"
                placeholder="Seleccione"
                :required="required ? 'required' : ''"
                fieldkey="signaturePositionId"
                fieldname="signaturePositionName"
                :options="options"
                :error="errors[0]"
                :custom-error-msg="errorMsgs['position']"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-12 mt-1">
            <ValidationProvider
              v-slot="{ errors }"
              immediate
              :rules="required && !isDisabled ? 'required' : ''"
            >
              <CustomInput
                v-model="internalValue.name"
                label="Nombre:"
                :disabled="isDisabled || nameDisabled"
                type="text"
                placeholder=""
                :error="errors[0]"
                :custom-error-msg="errorMsgs['name']"
              />
            </ValidationProvider>
          </div>
          <div v-if="!fullnameOnly && !isDisabled" class="col-md-4 col-12 mt-1">
            <ValidationProvider
              v-slot="{ errors }"
              immediate
              :rules="required && !isDisabled ? 'required' : ''"
            >
              <CustomInput
                v-model="internalValue.paternalName"
                label="Primer Apellido:"
                :disabled="isDisabled || nameDisabled"
                type="text"
                placeholder=""
                :error="errors[0]"
                :custom-error-msg="errorMsgs['paternalName']"
              />
            </ValidationProvider>
          </div>
          <div v-if="!fullnameOnly && !isDisabled" class="col-md-4 col-12 mt-3">
            <CustomInput
              v-model="internalValue.maternalName"
              label="Segundo Apellido (No es requerido):"
              :disabled="isDisabled || nameDisabled"
              type="text"
              placeholder=""
            />
          </div>
          <div
            class="col-md-4 col-12"
            :class="{
              'mt-3': !fullnameOnly && !isDisabled,
              'mt-1': fullnameOnly || isDisabled
            }"
          >
            <ValidationProvider
              v-slot="{ errors }"
              immediate
              :rules="required && !isDisabled ? 'required' : ''"
            >
              <CustomDropDown
                v-model="internalValue.participationId"
                label="Tipo de Participación:"
                :disabled="participationDisabled || isDisabled"
                placeholder="Tipo de Participación"
                :required="required ? 'required' : ''"
                fieldkey="id"
                fieldname="name"
                :options="participationTypes"
                :error="errors[0]"
                :custom-error-msg="errorMsgs['participation']"
                @input="() => $emit('update:participationTypes', internalValue.participationId)"
              />
            </ValidationProvider>
            <div class="mt-2">
              <ValidationProvider
                v-if="showAlternate"
                v-slot="{ errors }"
                immediate
                :rules="required && !isDisabled ? 'required' : ''"
              >
                <CustomDropDown
                  v-model="internalValue.alternateId"
                  label="Tipo de Participación Alterna:"
                  :disabled="isDisabled"
                  placeholder="Seleccione"
                  :required="required ? 'required' : ''"
                  fieldkey="id"
                  fieldname="name"
                  :options="alternateParticipations"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs['participation']"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isRemovable" class="col-md-2 col-12">
        <div class="dropdown py-3 text-center mt-3">
          <ActionButton
            :variant="isMobile ? 'danger btn-block' : 'danger'"
            class="px-1 actions p-2"
            i="fas fa-times-circle text-white pr-1"
            @click="deleteSignature()"
          >
            Eliminar
          </ActionButton>
        </div>
      </div>
      <Error
        v-if="isAbsentExcused"
        class="my-2 mx-4"
        is-alert-mode
        message="
          La ausencia excusada tiene que ser aceptada por todos los participantes del COMPU y documentada en minuta. Es importante que dicha minuta se adjunte en los documentos del PEI. Se le informa que, de no estar documentado en minuta, el COMPU no estaría debidamente constituido.
        "
      />
      <hr class="divider-horizontal" />
    </div>
  </ValidationObserver>
</template>

<script>
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import Error from "@/components/common/Error.vue";
import CustomDropDown from "custom-drop-down";
import participationTypes from "@/utils/constants/pei/participationTypes.js";
import { ValidationObserver } from "vee-validate";

export default {
  name: "EvaluationDiscussionATRow",
  components: {
    ValidationObserver,
    CustomInput,
    CustomDropDown,
    Error,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        name: "",
        paternalName: "",
        maternalName: "",
        positionId: { signaturePositionId: 0, name: null },
        participationId: { id: 0, name: null },
        alternateId: { id: 0, name: null }
      })
    },
    id: {
      type: Number,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    nameDisabled: {
      type: Boolean,
      default: false
    },
    positionDisabled: {
      type: Boolean,
      default: false
    },
    participationDisabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: Number,
      default: 0
    },
    groupName: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    participationTypes: {
      type: Array,
      default: () => []
    },
    alternateParticipations: {
      type: Array,
      default: () => []
    },
    isRemovable: {
      type: Boolean,
      default: true
    },
    fullnameOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalValue: { ...this.value },
      randomId: Math.floor(Math.random() * 1_000_000),
      errorMsgs: {
        name: "Debe escribir el nombre.",
        paternalName: "Debe escribir el primer apellido.",
        position: "Favor de seleccionar un puesto para continuar. (17027)",
        participation: "Favor de seleccionar un tipo de participación para continuar.",
        alternate: ""
      }
    };
  },
  mounted() {
    this.setValues();
  },
  methods: {
    deleteSignature() {
      this.$emit("deleteSignature", this.id);
    },
    async validate() {
      const ref = this.$refs[`participantsobserver-${this.randomId}`];
      if (ref && ref.validate) {
        return await ref.validate();
      }
      return false;
    },
    setValues() {
      const v = this.internalValue;
      v.positionId = v.positionId
        ? this.options.find(x => x.signaturePositionId === v.positionId.signaturePositionId)
        : undefined;
      v.participationId = v.participationId
        ? this.participationTypes.find(x => x.id === v.participationId.id)
        : undefined;
      v.alternateId = v.alternateId
        ? this.alternateParticipations.find(x => x.id === v.alternateId.id)
        : undefined;
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.internalValue = { ...newVal };
      }
    },
    internalValue: {
      deep: true,
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
          this.$emit("input", newVal);
        }
      }
    },
    "internalValue.participationId"(newVal) {
      if (newVal && newVal.id !== 2) {
        this.internalValue.alternateId = null;
      }
    }
  },
  computed: {
    required() {
      return (
        this.isRequired ||
        this.internalValue.name !== "" ||
        (this.internalValue.positionId &&
          this.internalValue.positionId.signaturePositionId === 0)
      );
    },
    isAbsentExcused() {
      return (
        this.internalValue.participationId &&
        this.internalValue.participationId.id === participationTypes.AbsentExcused
      );
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    showAlternate() {
      return this.internalValue.participationId &&
        this.internalValue.participationId.id === 2;
    }
  }
};
</script>
<style scoped>
.dot {
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
}
.text-red {
  color: #c9545e;
}
.text-center {
  text-align: center;
}
.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.dropdown-item {
  font: Bold 16px/19px Lato;
}

.divider-horizontal {
  border: 0.5px solid #e2e2e2;
  position: relative;
  top: 12px;
  width: 95%;
}
.orange-icon {
  color: #ff7058;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  display: block;
  width: 100%;
}
.dropdown-menu-width {
  width: 91%;
}
@media (min-width: 992px) {
  .btn-dropdown-actions {
    /* width: 4.5rem; */
    font-size: 0.7rem;
    margin-right: 0px;
    display: block;
    width: 100%;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    /* width: 7.4375rem; */
  }
}
.input-label {
  font: Bold 0.825rem Lato !important;
}
</style>
